import React from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { logOut } from '../redux/authSlice';
import { open } from '../redux/loginLayerSlice';

const Top: React.FC = () => {
    const dispatch = useAppDispatch();
    const handleOpenLayer = () => {
        dispatch(open("login"));
    }

    const handleLogout = () => {
        dispatch(logOut());
        window.location.href = process.env.REACT_APP_API_URL + "/member/member_Logout.asp?jvLogout=Y"
    }

    const memId = useAppSelector(state => state.auth.memId);
    return (
        <div className='head'>
            <div>
                <span>
                    {
                        memId ? (
                            <a href="#" onClick={handleLogout}>로그아웃</a>
                        ) : (
                            <a href="#" onClick={handleOpenLayer}>로그인</a>
                        )
                    }
                </span>
                <a href="https://kyobohealthcare.aimmed.com/mypage/myPage_info.asp">마이페이지</a>
                <a href="https://kyobohealthcare.aimmed.com/member/sitemap.asp">사이트맵</a>
                <a href='https://www.kyobo.co.kr/webdocs/view.jsp?screenId=SCOCONLM001&biztype=main'>교보생명 바로가기</a>
            </div>
        </div>
    )
}

export default Top;